import { connect } from "react-redux";
import Grid from "../../../../components/Grid";
import { EditPackagingButton } from "./EditPackagingButton";
import { DeletePackagingButton } from "./DeletePackagingButton";
import { useEffect, useMemo, useState } from "react";

const ActionsPackaging = (props) => {
  return (
    <>
      <EditPackagingButton {...props} />
      <DeletePackagingButton {...props} />
    </>
  );
};

const ContentPackagingComponent = ({
  packaging = [],
  logisticsOperators = [],
  countries = [],
  reduxGetPackaging = () => {},
  reduxGetLogisticsOperators = () => {},
  reduxGetCountries = () => {},
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [offset, setOffset] = useState(10);
  const [search, setSearch] = useState("");

  const itemsPackaging = Array.isArray(packaging?.items)
    ? packaging.items
    : [];

  const operatorsList = Array.isArray(logisticsOperators)
    ? logisticsOperators
    : logisticsOperators?.items || [];

  const operatorsById = useMemo(() => {
    const map = {};
    operatorsList.forEach((op) => {
      map[op.idCompany] = op;
    });
    return map;
  }, [operatorsList]);

  const countriesList = Array.isArray(countries)
    ? countries
    : countries?.items || [];

  const countriesById = useMemo(() => {
    const map = {};
    countriesList.forEach((c) => {
      map[c.idCountry] = c;
    });
    return map;
  }, [countriesList]);

  const COLUMNS = useMemo(() => [
    {
      title: "ID",
      render: (rowData) => {
        return <span>{rowData?.id || null}</span>;
      },
      field: "id",
      searchable: true,
    },
    {
      title: "Código",
      render: (rowData) => {
        return <span>{rowData?.code || ""}</span>;
      },
      field: "code",
      searchable: true,
    },
    {
      title: "Nombre",
      render: (rowData) => {
        return <span>{rowData?.name || ""}</span>;
      },
      field: "name",
      searchable: true,
    },
    {
      title: "Tipo",
      render: (rowData) => {
        return <span>{rowData?.packagingType || ""}</span>;
      },
      field: "packagingType",
      searchable: true,
    },
    {
      title: "Largo",
      render: (rowData) => <span>{rowData?.length ?? "--"}</span>,
      field: "length",
    },
    {
      title: "Ancho",
      render: (rowData) => <span>{rowData?.width ?? "--"}</span>,
      field: "width",
    },
    {
      title: "Alto",
      render: (rowData) => <span>{rowData?.height ?? "--"}</span>,
      field: "height",
    },
    {
      title: "Tolerancia %",
      render: (rowData) => {
        return <span>{rowData?.tolerancePercentage ?? "--"}</span>;
      },
    },
    {
      title: "Operador",
      render: (rowData) => {
        const operator = operatorsById[rowData?.operatorId];
        return <span>{operator?.description || "--"}</span>;
      },
    },
    {
      title: "País",
      render: (rowData) => {
        const country = countriesById[rowData?.countryId];
        return <span>{country?.description || rowData?.countryId || "--"}</span>;
      },
      field: "countryId",
      searchable: true,
    },
    {
      title: "Activo",
      render: (rowData) => {
        return <span>{rowData?.isActive ? "Sí" : "No"}</span>;
      },
    },
    {
      title: "Acciones",
      render: (rowData) => {
        return (
          <ActionsPackaging
            isActive={rowData.isActive}
            idPackaging={rowData.id}
          />
        );
      },
    },
  ], [operatorsById, countriesById]);

  const handleOnChangeRange = (value) => {
    setOffset(value);
    reduxGetPackaging({
      page: 1,
      offset: value,
      search: search,
    });
  };

  const handleOnChangeSearch = (value) => {
    setSearch(value);
    reduxGetPackaging({
      page: 1,
      offset: offset,
      search: value,
    });
  };

  useEffect(() => {
    reduxGetPackaging({
      page: currentPage,
      offset: offset,
      search: search,
    });
  }, [currentPage, offset, search, reduxGetPackaging]);

  useEffect(() => {
    reduxGetLogisticsOperators({});
  }, [reduxGetLogisticsOperators]);

  useEffect(() => {
    reduxGetCountries({
      page: 1,
      offset: 1000,
      search: "isActive|true",
    });
  }, [reduxGetCountries]);

  return (
    <div className="card shadow mb-4">
      <div className="card-header py-3">
        <h6 className="m-0 font-weight-bold text-primary">
          Listado de Embalajes
        </h6>
      </div>
      <div className="card-body">
        <Grid
          cols={COLUMNS}
          data={itemsPackaging}
          page={packaging?.page || currentPage}
          pages={packaging?.totalPages || 0}
          total={packaging?.total || 0}
          offset={offset}
          onChangePage={(page) => setCurrentPage(page)}
          onChangeRange={handleOnChangeRange}
          defaultValue={search}
          onChangeSearch={handleOnChangeSearch}
        />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    packaging: state.packagingState.packaging,
    logisticsOperators: state.companyState.logisticsOperators,
    countries: state.countryState.countries,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    reduxGetPackaging: (payload) =>
      dispatch({
        type: "FETCH_PACKAGING_REQUEST",
        value: payload,
      }),
    reduxGetLogisticsOperators: (payload) =>
      dispatch({
        type: "FETCH_COMPANIESBYLOGISTICSOPERATOR_REQUEST",
        value: payload,
      }),
    reduxGetCountries: (payload) =>
      dispatch({
        type: "FETCH_COUNTRIES_REQUEST",
        value: payload,
      }),
  };
};

export const ContentPackaging = connect(
  mapStateToProps,
  mapDispatchToProps,
)(ContentPackagingComponent);
